import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { General } from 'src/app/models/General';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-acceso',
  templateUrl: './modal-acceso.component.html',
  styleUrls: ['./modal-acceso.component.css']
})
export class ModalAccesoComponent implements OnInit {

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(public dialogRef: MatDialogRef<ModalAccesoComponent>, ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('ACCESO');


  }

  _nuevaDenuncia() {

    this._cerrarModal(1);

  }

  _infoCompl() {

    this._cerrarModal(2);

  }

  _cerrarModal(numCaso: number) {

    const dataReturn: General = new General();

    dataReturn.numCampo1 = numCaso;

    this.dialogRef.close(dataReturn);

  }

  _cancelar() {

    this.dialogRef.close();

  }

}
